<!-- licensesExpiring ? '85px' :  -->
<mat-drawer-container [ngStyle]="{ top: '50px' }" class="container">
  <mat-drawer
    [ngClass]="collapsed ? 'sidenav-small' : 'sidenav-big'"
    mode="side"
    opened
  >
    <div>
      <div class="section heading">
        <span *ngIf="!collapsed">
          {{ getApplicationTitle() }}
        </span>
      </div>

      <a
        *ngIf="customerService.getPermission(setRouteManagementKey(), 'view')"
        class="section"
        routerLink="home"
        routerLinkActive="active-link"
      >
        <mat-icon>home</mat-icon>
        <p *ngIf="!collapsed" class="label">
          {{ "MAIN.NAV.DASHBOARD" | translate }}
        </p>
      </a>

      <a
        *ngIf="customerService.getPermission('Staff', 'view')"
        class="section"
        routerLink="assets"
        routerLinkActive="active-link"
      >
        <mat-icon>person</mat-icon>
        <p *ngIf="!collapsed" class="label">
          {{ GET_NAME_OF_ASSET(this.selectedSub, true) | translate }}
        </p>
      </a>

      <a
        *ngIf="customerService.getPermission('Devices', 'view')"
        class="section"
        routerLink="devices"
        routerLinkActive="active-link"
      >
        <mat-icon>devices_other</mat-icon>
        <p *ngIf="!collapsed" class="label">
          {{ "MAIN.DASHBOARD.DEVICES" | translate }}
        </p>
      </a>

      <!-- Should track allAlerts from websocket service, filtered per usecase -->
      <a
        *ngIf="customerService.getPermission('Events', 'view')"
        class="section"
        routerLink="events"
        routerLinkActive="active-link"
      >
        <mat-icon>notifications_none</mat-icon>
        <p *ngIf="!collapsed" class="label">
          {{ "MAIN.NAV.SHELL.EVENTS" | translate }}
        </p>
        <span *ngIf="getAlertCount() > 0" class="alert-count">{{
          getAlertCount()
        }}</span>
      </a>

      <!-- Hid from Patient Flow 11/8/2024 -->
      <a
        *ngIf="
          customerService.getPermission(setRouteManagementKey(), 'view') &&
          selectedSub != 'temperature-monitoring' &&
          selectedSub != 'patient-flow' &&
          selectedSub != 'melt'
        "
        class="section"
        routerLink="dashboard"
        routerLinkActive="active-link"
      >
        <mat-icon>pie_chart</mat-icon>
        <p *ngIf="!collapsed" class="label">
          {{ "MAIN.NAV.SHELL.ALERT_METRICS" | translate }}
        </p>
      </a>

      <a
        *ngIf="customerService.getPermission('Reports', 'view')"
        class="section"
        [routerLink]="routeForReports()"
        routerLinkActive="active-link"
      >
        <mat-icon>insert_chart_outlined</mat-icon>
        <p *ngIf="!collapsed" class="label">
          {{ "MAIN.NAV.SHELL.REPORTS" | translate }}
        </p>
      </a>

      <a
        *ngIf="customerService.getPermission('Maps', 'view')"
        class="section"
        routerLink="sub-map"
        routerLinkActive="active-link"
      >
        <mat-icon class="material-icons-outlined">map</mat-icon>
        <p *ngIf="!collapsed" class="label">
          {{ "MAIN.DASHBOARD.MAP-REALTIME" | translate }}
        </p>
      </a>

      <!-- No Routes for 727 MKL 1-31-2025! -->
      <!-- <a
        *ngIf="
          this.selectedSub != 'hand-hygiene' &&
          this.selectedSub != 'temperature-monitoring' &&
          customerService.subscriptions.routeManagement &&
          customerService.subscriptions.routeManagement[setRouteManagementKey()]
        "
        class="section"
        routerLink="route-manager"
        routerLinkActive="active-link"
      >
        <mat-icon>alt_route</mat-icon>
        <p *ngIf="!collapsed" class="label">
          {{ "MAIN.NAV.SHELL.ROUTES" | translate }}
        </p>
      </a> -->

      <!-- Rules ARE needed on Temp -->
      <a
        *ngIf="
          customerService.getPermission('Rules', 'view') &&
          customerService.subscriptions.ruleManagement &&
          showRules()
        "
        class="section"
        routerLink="sub-rule"
        routerLinkActive="active-link"
      >
        <mat-icon>rule</mat-icon>
        <p *ngIf="!collapsed" class="label">
          {{ "MAIN.DASHBOARD.RULES" | translate }}
        </p>
      </a>

      <!-- Staff Safety settings? MKL -->
      <a
        *ngIf="
          customerService.getPermission('Settings', 'view') &&
          (this.selectedSub === 'asset-tracking' ||
            this.selectedSub === 'hand-hygiene' ||
            this.selectedSub === 'sdct' ||
            this.selectedSub === 'melt' ||
            this.selectedSub === 'temperature-monitoring' ||
            this.selectedSub === 'bed-management' ||
            this.selectedSub === 'patient-flow')
        "
        class="section"
        routerLink="settings"
        routerLinkActive="active-link"
      >
        <mat-icon>settings</mat-icon>
        <p *ngIf="!collapsed" class="label">
          {{ "MAIN.DASHBOARD.SETTINGS" | translate }}
        </p>
      </a>
    </div>
  </mat-drawer>
  <router-outlet></router-outlet>
</mat-drawer-container>
